import React from 'react';
import { Chip, useAuth, useIsMobile, useT } from '@repo/common';

const statusLabelsKr = {
  All: '전체',
  Paid: '결제 완료',
  Pending: '대기 중',
  Canceled: '취소됨',
  Refunded: '환불 완료',
  Expired: '만료됨',
};

const statusMapper = {
  All: 'ALL',
  Paid: 'PAID',
  Pending: 'PENDING_GROUP',
  Refunded: 'REFUNDED',
};

const adminStatusMapper = {
  All: 'ALL',
  Paid: 'PAID',
  Pending: 'PENDING_GROUP',
  Canceled: 'CANCELED',
  Refunded: 'REFUNDED',
  Expired: 'EXPIRED',
};

const PaymentsHeaderButton = ({ currentFilter, onFilterChange }) => {
  const t = useT();
  const { user } = useAuth();
  const isMobile = useIsMobile();
  const isAdmin = user?.role === 'A';
  const mapper = isAdmin ? adminStatusMapper : statusMapper;
  const entries = Object.entries(mapper);

  if (isMobile) {
    return (
      <div className='flex items-center p-1 rounded-[20px] bg-grayscale-gray02/50 h-[42px] w-full'>
        {entries.map(([label, mappedValue]) => {
          const isSelected = currentFilter === mappedValue;

          return (
            <button
              key={mappedValue}
              type='button'
              onClick={() => onFilterChange(mappedValue)}
              className={`flex-1 min-w-0 whitespace-nowrap p-2 typo-b13Strong transition-colors ${
                isSelected
                  ? 'bg-grayscale-gray00 text-text-primary rounded-[15px] shadow-3'
                  : 'bg-transparent text-text-secondary'
              }`}
            >
              {t(label, statusLabelsKr[label] || label)}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className='flex items-center gap-2'>
      {entries.map(([label, mappedValue]) => {
        const isSelected = currentFilter === mappedValue;

        return (
          <Chip
            key={mappedValue}
            type='fill'
            state={isSelected ? 'selected' : 'default'}
            hideIcon={true}
            onClick={() => onFilterChange(mappedValue)}
            borderclass='ring-0'
          >
            {t(label, statusLabelsKr[label] || label)}
          </Chip>
        );
      })}
    </div>
  );
};

export default PaymentsHeaderButton;
